
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, [_createElement('svg', {
            'className': 'icon icon--sports_car custom-icon cm_icon',
            'aria-hidden': 'true',
            'focusable': 'false',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '34.0',
            'height': '34.0',
            'viewBox': '0 0 512 512',
            'key': '1740'
        }, _createElement('path', {
            'd': 'M469.71 234.6c-7.33-9.73-34.56-16.43-46.08-33.94s-20.95-55.43-50.27-70S288 112 256 112s-88 4-117.36 18.63-38.75 52.52-50.27 70-38.75 24.24-46.08 33.97S29.8 305.84 32.94 336s9 48 9 48h86c14.08 0 18.66-5.29 47.46-8 31.6-3 62.6-4 80.6-4s50 1 81.58 4c28.8 2.73 33.53 8 47.46 8h85s5.86-17.84 9-48-2.04-91.67-9.33-101.4zM400 384h56v16h-56zM56 384h56v16H56z',
            'className': 'fill-none stroke-width-standard',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
        }), _createElement('path', { 'd': 'M364.47 309.16c-5.91-6.83-25.17-12.53-50.67-16.35S279 288 256.2 288s-33.17 1.64-57.61 4.81-42.79 8.81-50.66 16.35C136.12 320.6 153.42 333.44 167 335c13.16 1.5 39.47.95 89.31.95s76.15.55 89.31-.95c13.56-1.65 29.62-13.6 18.85-25.84zM431.57 243.05a3.23 3.23 0 00-3.1-3c-11.81-.42-23.8.42-45.07 6.69a93.88 93.88 0 00-30.08 15.06c-2.28 1.78-1.47 6.59 1.39 7.1a455.32 455.32 0 0052.82 3.1c10.59 0 21.52-3 23.55-12.44a52.41 52.41 0 00.49-16.51zM80.43 243.05a3.23 3.23 0 013.1-3c11.81-.42 23.8.42 45.07 6.69a93.88 93.88 0 0130.08 15.06c2.28 1.78 1.47 6.59-1.39 7.1a455.32 455.32 0 01-52.82 3.1c-10.59 0-21.52-3-23.55-12.44a52.41 52.41 0 01-.49-16.51z' }), _createElement('path', {
            'className': 'fill-none stroke-width-standard',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            'd': 'M432 192h16M64 192h16M78 211s46.35-12 178-12 178 12 178 12'
        }))], this.size ? _createElement('span', {
        'className': 'garage-size',
        'key': '1653'
    }, this.size) : null), _createElement('span', { 'className': 'garage-label' }, _createElement('span', { 'className': 'garage-label_title' }, this.isSelected ? this.vehicleBaseValues.join(' ') : _translate(`garage_title`)), _createElement('span', { 'className': 'garage-label_subtitle' }, _translate(`garage_subtitle`)))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '1930'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  cm_button cm_button__primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1408'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  cm_button cm_button__primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]